import {
  ADD_SELECTED_TRANSACTION,
  REMOVE_SELECTED_TRANSACTION,
  RESET_SELECTED_TRANSACTIONS,
  ADD_SELECTED_PAGE,
  REMOVE_SELECTED_PAGE,
  SET_TRANSACTIONS,
  RESET_SELECTED_PAGES,
  UPDATE_TRANSACTIONS,
  CLEAR_TRANSACTIONS,
  MARK_AS_SEEN_TRANSACTIONS,
} from '../ActionTypes';

export const addSelectedTransaction = id => ({
  type: ADD_SELECTED_TRANSACTION,
  payload: id,
});

export const removeSelectedTransaction = id => ({
  type: REMOVE_SELECTED_TRANSACTION,
  payload: id,
});

export const resetSelectedTransactions = () => ({
  type: RESET_SELECTED_TRANSACTIONS,
});

export const addSelectedPage = (page, ids) => ({
  type: ADD_SELECTED_PAGE,
  payload: {
    page,
    ids,
  },
});

export const removeSelectedPage = (page, ids) => ({
  type: REMOVE_SELECTED_PAGE,
  payload: {
    page,
    ids,
  },
});

export const resetSelectedPages = () => ({
  type: RESET_SELECTED_PAGES,
});

export const setTransactions = transactions => ({
  type: SET_TRANSACTIONS,
  payload: transactions,
});

export const updateTransactions = transactions => ({
  type: UPDATE_TRANSACTIONS,
  payload: {
    newTransactions: transactions,
  },
});

export const clearTransactions = () => ({
  type: CLEAR_TRANSACTIONS,
});

export const markAsSeenTransactions = selected => ({
  type: MARK_AS_SEEN_TRANSACTIONS,
  payload: {
    transactions: selected,
  },
});
